import React from 'react';

import PropTypes from 'prop-types';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelContent, PanelFrame, PanelRow, PanelText } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';

export const PanelWithCheck = ({ negativeMargin = true, type = 'div', ...props }) => {
    const isSelected = props.isSelected || (props.id && props.id === props.selectedPanelId);
    return (
        <Panel
            onClick={props.onClick}
            isHoverable
            negativeMargin={negativeMargin}
            isSelectedPanel={isSelected}
            type={type}
            href={props.href}
            dataTestId={props.dataTestId}
        >
            <PanelFrame>
                <PanelContent>
                    <PanelRow>
                        <PanelText multiline={!!props.secondaryText}>
                            <Text>{props.mainText}</Text>
                        </PanelText>
                    </PanelRow>
                    {props.secondaryText && (
                        <PanelRow>
                            <Text color="secondary" size="secondary">
                                {props.secondaryText}
                            </Text>
                        </PanelRow>
                    )}
                </PanelContent>
                {isSelected && <Icon name="check" color="primary" leftIndent="8px" />}
            </PanelFrame>
        </Panel>
    );
};

PanelWithCheck.propTypes = {
    id: PropTypes.string,
    onClick: PropTypes.func,
    mainText: PropTypes.string,
    secondaryText: PropTypes.string,
    selectedPanelId: PropTypes.string,
    isSelected: PropTypes.bool,
};
